










































































































































import { defineComponent } from "@vue/composition-api";
import NumberFormatter from "@/services/number.formatter";
import { Interval, createNewDefaultInterval } from "@/models/Interval";
import FeeBase from "@/models/FeeBase";
import { BlockLabel } from "@/models/BlockLabel";
import {
  TextField,
  Expandable,
  Checkbox,
  BlockContainer,
} from "@/components";

export default defineComponent({
  name: "Percentage",
  components: {
    Expandable,
    TextField,
    Checkbox,
    BlockContainer,
  },
  props: {
    initialLimit: { type: Number, default: 0 },
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: { type: Object, default: null },
  },
  data() {
    return {
      displayName: BlockLabel.Percentage,
      startsAt: this.initialLimit || 0,
      trappe: false,
      intervals: Array<Interval>(),
      infiniteUpperLimit: false,
      feeBase: FeeBase.SalaryBase,
      feeBaseDescription: "",
    };
  },
  computed: {
    FeeBase() {
      return FeeBase;
    },
  },
  mounted() {
    if (this.data) {
      this.startsAt = this.data.startsAt;
      this.trappe = this.data.trappe;
      this.intervals = this.data.intervals;
      this.infiniteUpperLimit = this.data.infiniteUpperLimit;
      this.feeBase = Object.values(FeeBase)[this.data.feeBase];
      this.feeBaseDescription = this.data.feeBaseDescription;
    } else {
      this.addInterval();
    }
  },
  methods: {
    addInterval() {
      var newInterval = createNewDefaultInterval(this.intervals, {
        startsAt: this.startsAt,
        defaultAmount: 1.25,
      });
      this.intervals.push(newInterval);
    },
    removeInterval() {
      this.intervals.pop();
    },
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        intervals: this.intervals,
        trappe: this.trappe,
        startsAt: this.startsAt,
        feeBase: this.getFeeBaseIndex(this.feeBase),
        feeBaseDescription: this.getFeeBaseDescription(),
        infiniteUpperLimit: this.infiniteUpperLimit,
      });
      this.$emit(
        "highestIntervalValue",
        this.intervals[this.intervals.length - 1].upperLimit
      );
    },
    getFeeBaseIndex(value: string): number {
      const index = Object.values(FeeBase).indexOf(value);
      return index;
    },
    getFeeBaseLabel(): string {
      const index = this.getFeeBaseIndex(this.feeBase);
      return index == 2
        ? this.feeBaseDescription
        : Object.values(FeeBase)[index];
    },
    getFeeBaseDescription(): string | undefined {
      let index = this.getFeeBaseIndex(this.feeBase);
      return index == 2 ? this.feeBaseDescription : undefined;
    },
    getLowerLimit(index: number): number {
      if (index == 0) return this.startsAt;

      return this.intervals[index - 1].upperLimit;
    },
    getNewColor(index: number): string {
      var colors = ["#39CCCC", "#FF9186", "#B4DA55", "#B5649b"];

      index = index % colors.length;

      return colors[index];
    },
    shortenedNumber(number: number): string {
      return NumberFormatter.shortForm(number, 3);
    },
    asPercentage(number: number) {
      return `${number}%`;
    },
    isLast(list: Array<any>, index: number) {
      return index + 1 == list.length;
    },
  },
});
